export const phoneReplace = (value: string): string => {
  if (!value) {
    return '-'
  }

  value = value.replace(/\D/g, '')

  if (value.length >= 10) {
    const ddd = value.slice(0, 2)

    const firstPhonePart = value.slice(2, 7)

    const lastPhonePart = value.slice(7)

    return `(${ddd}) ${firstPhonePart}-${lastPhonePart}`
  } else {
    return value
  }
}
